import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

// Both calls share size, shape and width: buying and selling weigh the same on the landing
// (COR-1). Only the colour tells them apart, and both keep full contrast on the dark hero.
const callSx = {
  flex: { xs: 1, sm: '0 1 240px' },
  py: 1.75,
  fontSize: '1.0625rem',
} as const;

/**
 * The first thing a visitor sees: what PhoneTec is and the two ways in. It stays short so both
 * calls fit above the fold on a 360 px phone.
 */
export function HomeHero() {
  return (
    <Box
      component="section"
      aria-labelledby="home-hero-title"
      sx={{
        p: { xs: 3, md: 6 },
        borderRadius: 5,
        background: '#0B0D10',
        color: 'common.white',
      }}
    >
      <Stack spacing={{ xs: 2, md: 2.5 }} sx={{ maxWidth: 720 }}>
        <Typography
          variant="overline"
          sx={{ color: 'primary.main', letterSpacing: '.12em', lineHeight: 1.5 }}
        >
          USADOS CERTIFICADOS PHONETEC
        </Typography>
        <Typography id="home-hero-title" variant="h1">
          Usados, pero con respaldo.
        </Typography>
        <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.8)' }}>
          Comprá un equipo revisado y certificado por PhoneTec, o cotizá el tuyo para venderlo.
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ pt: 1 }}>
          <Button
            component={RouterLink}
            to="/catalog"
            variant="contained"
            color="primary"
            size="large"
            startIcon={<StorefrontOutlinedIcon />}
            sx={callSx}
          >
            Comprar
          </Button>
          <Button
            component={RouterLink}
            to="/quotation-request"
            variant="contained"
            size="large"
            startIcon={<PhoneIphoneOutlinedIcon />}
            sx={{
              ...callSx,
              bgcolor: 'common.white',
              color: 'text.primary',
              '&:hover': { bgcolor: '#E6E8EC' },
            }}
          >
            Vender
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
